var map = {
	"./image-cards.de-CH.json": 1346,
	"./image-cards.de-DE.json": 1347,
	"./image-cards.en-CA.json": 1348,
	"./image-cards.en-GB.json": 1349,
	"./image-cards.en-IN.json": 1350,
	"./image-cards.en-ME.json": 1351,
	"./image-cards.en-US.json": 1352,
	"./image-cards.es-EM.json": 1353,
	"./image-cards.es-ES.json": 1354,
	"./image-cards.fr-BE.json": 1355,
	"./image-cards.fr-CA.json": 1356,
	"./image-cards.fr-CH.json": 1357,
	"./image-cards.nl-BE.json": 1358,
	"./image-cards.nl-NL.json": 1359,
	"./image-cards.pl-PL.json": 1360,
	"./image-cards.pt-BR.json": 1361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1345;